export default "__VITE_ASSET__Bsi5r$72__"